import React, { useEffect, useState, useContext, useMemo } from "react";

import axios from "../context/AxiosInstance";

import { Table, Button, Form, Spinner } from "react-bootstrap";

import { useNavigate } from "react-router-dom";

import { AuthContext } from "../context/AuthContext";

import { toast } from "react-toastify";

import Swal from "sweetalert2";

import Navbar from "../components/Navbar";

import AppBreadcrumb from "../components/AppBreadcrumb";

import Sidebar from "../components/Sidebar";

import ContratFormModal from "../components/contrat/ContratFormModal";

import ConfirmDeleteModal from "../components/contrat/ConfirmDeleteModal";

import EmptyState from "../components/common/EmptyState";

import RhKpiCard from "../components/common/RhKpiCard";
import RhTablePagination from "../components/common/RhTablePagination";

import { FaFileContract, FaSearch, FaPlus, FaPen, FaTrash, FaSync } from "react-icons/fa";

import "../styles/rh-modern-ui.css";

import "./ContratsPage.css";



const isDateFinOuverte = (dateFin) => {

  if (!dateFin) return true;

  const s = String(dateFin).trim();

  return !s || s === "0000-00-00" || s.startsWith("0000-");

};



const ContratsPage = () => {

  const { token, role } = useContext(AuthContext);

  const navigate = useNavigate();



  const [contrats, setContrats] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1);

  const [perPage, setPerPage] = useState(10);



  const [showFormModal, setShowFormModal] = useState(false);

  const [isEditMode, setIsEditMode] = useState(false);

  const [selectedContrat, setSelectedContrat] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);



  const [loading, setLoading] = useState(true);

  const [unauthorized, setUnauthorized] = useState(false);

  const [updatingDurees, setUpdatingDurees] = useState(false);



  const contratsActifsCount = (contrats || []).filter((c) => isDateFinOuverte(c.date_fin)).length;



  const fetchContrats = async () => {

    setLoading(true);

    if (role !== "RH" && role !== "Assistant" && role !== "ASSISTANT") {

      setUnauthorized(true);

      setLoading(false);

      return;

    }



    try {

      const res = await axios.get("/contrats/", {

        headers: { Authorization: `Bearer ${token}` },

      });

      setContrats(Array.isArray(res.data?.data) ? res.data.data : []);

    } catch (err) {

      if (err.response?.status === 401 || !token) {

        navigate("/login");

      } else {

        console.error("Erreur de chargement :", err);

      }

    } finally {

      setLoading(false);

    }

  };



  useEffect(() => {

    if (token && role) {

      fetchContrats();

    }

  }, [token, role]);



  const filtered = (contrats || []).filter((c) =>

    `${c.type_contrat} ${c.poste || ""} ${c.service || ""} ${c.departement || ""} ${c.lieu || ""} ${c.nom_employe || ""} ${c.prenom_employe || ""}`

      .toLowerCase()

      .includes(searchTerm.toLowerCase())

  );



  const kpis = useMemo(() => {

    const list = contrats || [];

    const enCours = list.filter((c) => isDateFinOuverte(c.date_fin)).length;

    const termines = list.length - enCours;

    const cdi = list.filter((c) => (c.type_contrat || "").toUpperCase() === "CDI").length;

    const cdd = list.filter((c) => (c.type_contrat || "").toUpperCase() === "CDD").length;

    const departements = new Set(list.map((c) => c.departement).filter(Boolean)).size;

    return { total: list.length, enCours, termines, cdi, cdd, departements };

  }, [contrats]);



  const totalPages = Math.ceil(filtered.length / perPage);

  const currentData = filtered.slice(

    (currentPage - 1) * perPage,

    currentPage * perPage

  );



  const openForm = (c = null) => {

    setSelectedContrat(c);

    setIsEditMode(!!c);

    setShowFormModal(true);

  };



  const openDelete = (c) => {

    setSelectedContrat(c);

    setShowDeleteModal(true);

  };



  const handleActualiserDurees = async () => {

    const result = await Swal.fire({

      title: "Actualiser les durées ?",

      html: `

        <p class="mb-2">Recalcule la durée pour les contrats <strong>en cours</strong>

        (date de fin vide ou <code>0000-00-00</code>) :</p>

        <p class="mb-0"><strong>durée = aujourd'hui − date de début</strong></p>

        <p class="text-muted small mt-2 mb-0">

          Les contrats avec une date de fin renseignée (fin de contrat) ne seront pas modifiés.

        </p>

        <p class="mt-2 mb-0"><strong>${contratsActifsCount}</strong> contrat(s) éligible(s) sur cette liste.</p>

      `,

      icon: "question",

      showCancelButton: true,

      confirmButtonText: "Actualiser",

      cancelButtonText: "Annuler",

      confirmButtonColor: "#4f46e5",

    });



    if (!result.isConfirmed) return;



    setUpdatingDurees(true);

    try {

      const res = await axios.post("/contrats/actualiser-durees-actives/", null, {

        headers: { Authorization: `Bearer ${token}` },

      });

      const { updated, skipped_fin_contrat, message } = res.data || {};

      await Swal.fire({

        title: "Actualisation terminée",

        html: `

          <p><strong>${updated ?? 0}</strong> durée(s) mise(s) à jour.</p>

          <p class="text-muted small mb-0">${skipped_fin_contrat ?? 0} contrat(s) en fin de contrat ignoré(s).</p>

        `,

        icon: "success",

      });

      toast.success(message || "Durées actualisées");

      fetchContrats();

    } catch (err) {

      const msg = err.response?.data?.detail?.message

        || err.response?.data?.detail

        || "Erreur lors de l'actualisation des durées";

      toast.error(typeof msg === "string" ? msg : "Erreur lors de l'actualisation");

      Swal.fire({ title: "Erreur", text: typeof msg === "string" ? msg : "Échec de l'actualisation", icon: "error" });

    } finally {

      setUpdatingDurees(false);

    }

  };



  const canEdit = role === "RH" || role === "Assistant" || role === "ASSISTANT";



  return (

    <div className="d-flex">

      <Sidebar />

      <div className="main-content w-100">

        <Navbar />



        <div className="container-fluid p-4 p-lg-5 rh-page-content">

          <AppBreadcrumb items={[{ label: "Accueil", to: "/" }, { label: "Contrats" }]} />



          <header className="rh-page-header">

            <h4>

              <span className="rh-page-icon"><FaFileContract /></span>

              Gestion des contrats

            </h4>

            <p>Suivi des contrats en cours et terminés, recherche multi-critères et actualisation des durées.</p>

          </header>



          {loading ? (

            <div className="rh-loading-block">

              <Spinner animation="border" />

              <p className="mt-3 mb-0">Chargement des contrats…</p>

            </div>

          ) : unauthorized ? (

            <div className="rh-alert-unauth">Données non permises pour cet utilisateur</div>

          ) : (

            <>

              <div className="rh-kpi-grid">

                <RhKpiCard label="Total contrats" value={kpis.total} variant="primary" sub="Enregistrés dans le système" />

                <RhKpiCard label="En cours" value={kpis.enCours} variant="success" sub="Sans date de fin" />

                <RhKpiCard label="Terminés" value={kpis.termines} variant="neutral" sub="Date de fin renseignée" />

                <RhKpiCard label="CDI" value={kpis.cdi} variant="info" />

                <RhKpiCard label="CDD" value={kpis.cdd} variant="warning" />

                <RhKpiCard label="Départements" value={kpis.departements} variant="neutral" sub="Services distincts" />

              </div>



              <div className="rh-toolbar">

                <div className="rh-toolbar-left">

                  <div className="rh-search-wrap">

                    <FaSearch className="rh-search-icon" />

                    <Form.Control

                      type="text"

                      placeholder="Type, poste, service, département, lieu, employé…"

                      value={searchTerm}

                      onChange={(e) => setSearchTerm(e.target.value)}

                    />

                  </div>

                  <span className="rh-result-pill">{filtered.length} résultat{filtered.length !== 1 ? "s" : ""}</span>

                </div>

                <div className="rh-toolbar-actions">

                  {canEdit && (

                    <Button

                      variant="outline-primary"

                      className="rh-btn-outline rh-btn-outline-info btn-actualiser-durees"

                      onClick={handleActualiserDurees}

                      disabled={updatingDurees || contratsActifsCount === 0}

                      title="Recalcule la durée (aujourd'hui − date début) pour les contrats sans date de fin"

                    >

                      {updatingDurees ? (

                        <>

                          <Spinner animation="border" size="sm" />

                          Actualisation…

                        </>

                      ) : (

                        <>

                          <FaSync /> Actualiser durées ({contratsActifsCount})

                        </>

                      )}

                    </Button>

                  )}

                  <Button className="rh-btn-primary" onClick={() => openForm(null)}>

                    <FaPlus /> Ajouter un contrat

                  </Button>

                </div>

              </div>



              <div className="rh-table-panel">

                {currentData.length > 0 ? (

                  <>

                    <div className="table-responsive">

                      <Table hover className="rh-modern-table mb-0">

                        <thead>

                          <tr>

                            <th>Type</th>

                            <th>Poste</th>

                            <th>Département</th>

                            <th>Lieu</th>

                            <th>Date début</th>

                            <th>Date fin</th>

                            <th>Durée</th>

                            <th>Employé</th>

                            <th className="text-center">Actions</th>

                          </tr>

                        </thead>

                        <tbody>

                          {currentData.map((c) => (

                            <tr key={c.id_contrat}>

                              <td>

                                <span className="rh-badge rh-badge-indigo">{c.type_contrat}</span>

                              </td>

                              <td>{c.poste || "—"}</td>

                              <td>{c.departement || "—"}</td>

                              <td>{c.lieu || "—"}</td>

                              <td>{c.date_debut}</td>

                              <td>

                                {isDateFinOuverte(c.date_fin) ? (

                                  <span className="rh-badge rh-badge-green">En cours</span>

                                ) : (

                                  c.date_fin

                                )}

                              </td>

                              <td>{c.duree_annees || "—"}</td>

                              <td>

                                <strong>{c.nom_employe}</strong> {c.prenom_employe}

                              </td>

                              <td>

                                <div className="rh-row-actions">

                                  {canEdit ? (

                                    <>

                                      <Button

                                        size="sm"

                                        variant="outline-success"

                                        className="rh-action-btn"

                                        onClick={() => openForm(c)}

                                      >

                                        <FaPen /> Modifier

                                      </Button>

                                      {role === "RH" && (

                                        <Button

                                          size="sm"

                                          variant="outline-danger"

                                          className="rh-action-btn"

                                          onClick={() => openDelete(c)}

                                        >

                                          <FaTrash /> Supprimer

                                        </Button>

                                      )}

                                    </>

                                  ) : (

                                    <span className="text-muted small">Aucune action</span>

                                  )}

                                </div>

                              </td>

                            </tr>

                          ))}

                        </tbody>

                      </Table>

                    </div>



                    <RhTablePagination
                      currentPage={currentPage}
                      totalItems={filtered.length}
                      perPage={perPage}
                      onPageChange={setCurrentPage}
                      onPerPageChange={(n) => { setPerPage(n); setCurrentPage(1); }}
                      itemLabel="contrats"
                    />

                  </>

                ) : (

                  <div className="p-4">

                    <EmptyState title="Aucun contrat" description="Ajoutez un contrat pour commencer ou modifiez les filtres." />

                  </div>

                )}

              </div>

            </>

          )}

        </div>



        <ContratFormModal

          show={showFormModal}

          handleClose={() => setShowFormModal(false)}

          isEditMode={isEditMode}

          selectedContrat={selectedContrat}

          token={token}

          refreshData={fetchContrats}

        />



        <ConfirmDeleteModal

          show={showDeleteModal}

          handleClose={() => setShowDeleteModal(false)}

          employe={selectedContrat}

          token={token}

          refreshData={fetchContrats}

        />

      </div>

    </div>

  );

};



export default ContratsPage;

